<template>
  <div class="container" style="background:#fff;padding:0px; ">
    <topOp> </topOp>
    <div class="row">
      <div class="col-md-12">
        <div class="horasExtras">
          <h3 style="font-style:italic;font-weight: 700;">
            Calculadora da Rescisão de Contrato de Trabalho
          </h3>
          <div class="formAjuste" style="margin-top:90px;">
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Data de início do contrato de trabalho:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text"><i class="fa fa-calendar" style="color:#808080;"></i></div>
              </div>
              <input type="text" class="form-control formatacaoInput" maxlength="10" v-model="dataInicio"
                placeholder="DD/MM/AAAA">
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Data de término do contrato de trabalho:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text"><i class="fa fa-calendar" style="color:#808080;"></i></div>
              </div>
              <input type="text" placeholder="DD/MM/AAAA" v-model="dataFim" maxlength="10"
                class="form-control formatacaoInput">
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Motivo do término do contrato de trabalho:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="fa fa-vcard" style="font-size:16px;color:#808080;"></i></div>
              </div>
              <select @click="recisaoF()" name="" id="motivoTermino"
                style="width:325px;height:43px;border-top-right-radius: 10px;border-bottom-right-radius: 10px;">
                <option value="0">Selecionar</option>
                <option value="2">Pedido de demissão</option>
                <option value="1">Dispensa sem justa causa</option>
                <option value="3">Dispensa com justa causa</option>
                <option value="4">Rescisão antecipada do contrato de experiência pelo empregado</option>
                <option value="5">Rescisão antecipada do contrato de experiência pelo empregador</option>
              </select>
            </div>
            <p v-show="recisao" style="text-align:left;margin-bottom:-11px;padding:0px;">Data do Afastamento:
            <p>
            <div class="input-group mb-3 mr-sm-2" v-if="recisao">
              <div class="input-group-prepend">
                <div class="input-group-text"><i class="fa fa-calendar" style="color:#808080;"></i></div>
              </div>
              <input type="text" class="form-control formatacaoInput" maxlength="10" v-model="dataAfastamento"
                placeholder="DD/MM/AAAA">
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Ùltimo Salário Fixo:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="fa fa-calendar" style="font-size:16px;color:#808080;"></i>
                </div>
              </div>
              <money class="form-control formatacaoInput" v-model="salario" v-bind="money"
                @keydown.native="$event.key === '-' ? $event.preventDefault() : null"></money>
            </div>
            <p v-show="!recisao" style="text-align:left;margin-bottom:-11px;padding:0px;">Empregado possui férias
              vencidas?
            <p>
            <div v-show="!recisao" class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="fa fa-vcard" style="font-size:16px;color:#808080;"></i></div>
              </div>
              <select name="" id="possuiFe"
                style="width:325px;height:43px;border-top-right-radius: 10px;border-bottom-right-radius: 10px;">
                <option value="0">Selecionar</option>
                <option value="1">Sim</option>
                <option value="2">Não</option>
              </select>
            </div>
            <p v-show="!recisao" style="text-align:left;margin-bottom:-11px;padding:0px;">Ferias Gozadas:
            <p>
            <div v-show="!recisao" class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="fa fa-calendar" style="font-size:16px;color:#808080;"></i>
                </div>
              </div>
              <input type="number" class="form-control formatacaoInput" v-model="feriasGoazadas">
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Dependentes para salário família:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="fa fa-calendar" style="font-size:16px;color:#808080;"></i>
                </div>
              </div>
              <input type="number" class="form-control formatacaoInput" v-model="dependeteSalario">
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Dependentes para o IR :
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="fa fa-calendar" style="font-size:16px;color:#808080;"></i>
                </div>
              </div>
              <input type="number" class="form-control formatacaoInput" v-model="dependeteIR">
            </div>
            <p v-show="!recisao" style="text-align:left;margin-bottom:-11px;padding:0px;">Tipo do Aviso Prévio
            <p>
            <div v-show="!recisao" class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="fa fa-vcard" style="font-size:16px;color:#808080;"></i></div>
              </div>
              <select name="" id="avisoPrevio"
                style="width:325px;height:43px;border-top-right-radius: 10px;border-bottom-right-radius: 10px;">
                <option value="">Selecionar</option>
                <option value="2">Trabalhado</option>
                <option value="1">Indenizado</option>
              </select>
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Funcionário possui descontos nas verbas
              rescisórias
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="fa fa-vcard" style="font-size:16px;color:#808080;"></i></div>
              </div>
              <select name="" id="verdas"
                style="width:325px;height:43px;border-top-right-radius: 10px;border-bottom-right-radius: 10px;">
                <option value="">Selecionar</option>
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </select>
            </div>
            <br>
            <a href="#horasExtrasresultado.verbasRescisorias1"><button :disabled="disabled" class="calcular"
                @click="calcular()">calcular <b-spinner v-show="spiner" style="width: 1.5rem;height: 1.5rem;"
                  small></b-spinner> </button></a>
            <br>
            <br>
            <span style="color:red;" v-show="erro">Erro no cálculo. Por favor revise os campos!</span>
            <br>
          </div>
        </div>
      </div>
    </div>

    <div class="horasExtrasresultado" id="horasExtrasresultado1" style="background:#BEBEBE;" v-if="resuIs">
      <h3 style="font-style:italic;">
        Resultado do Cálculo
      </h3>
      <div id="formAjuste2">
        <p class="pResult" align="center">O valor líquido (depois dos descontos) é de:</p>
        <p style="    font-weight: bold;">{{ resultado.totalLiquido }}</p>

        <p style="cursor:pointer;font-weight: 600;font-size:18px;" @click="verCon = !verCon">Ver detalhamento do valor
        </p>
      </div>
      <div class="contrato" v-show="verCon">
        <table class="t01">
          <tr>
            <th colspan="2">
              Verbas Rescisórias
            </th>
          </tr>
          <tr>
            <td class="ladoEs">
              Aviso Prévio
            </td>
            <td>
              {{ resultado.verbasRescisorias.avisoPrevio }}<br> {{ resultado.verbasRescisorias.avisoPrevioTexto }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              13º Salário
            </td>
            <td>
              {{ resultado.verbasRescisorias.valor13Salario }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              13º Salário Indenizado
            </td>
            <td>
              {{ resultado.verbasRescisorias.valor13SalarioIndenizado }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              Férias Vencidas
            </td>
            <td>
              {{ resultado.verbasRescisorias.feriasVencias }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              Férias Indenizadas
            </td>
            <td>
              {{ resultado.verbasRescisorias.feriasIndenizadas }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              Férias Proporcionais
            </td>
            <td>
              {{ resultado.verbasRescisorias.feriasProporcionais }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              1/3 Férias
            </td>
            <td>
              {{ resultado.verbasRescisorias.valorUmTercoFerias }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              Saldo Salário
            </td>
            <td>
              {{ resultado.verbasRescisorias.saldoSalario }}
            </td>
          </tr>
          <tr v-if="resultado.mostrarSalarioFamilia">
            <td class="ladoEs">
              Salário Família
            </td>
            <td>
              {{ resultado.salarioFamilia }}
            </td>
          </tr>
          <tr v-if="resultado.mostrarIndenizacao">
            <td class="ladoEs">
              Indenização Quebra de Contrato
            </td>
            <td>
              {{ resultado.indenizacaoQuebraContrato }}
            </td>
          </tr>



          <tr>
            <td class="ladoEs" style="background:#E8E8E8;">
              Total Bruto
            </td>
            <td style="background:#E8E8E8;">
              {{ resultado.verbasRescisorias.totalBruto }}
            </td>
          </tr>
        </table>
        <br>
        <table class="t01">
          <tr>
            <th colspan="2">
              INSS
            </th>
          </tr>
          <tr>
            <td class="ladoEs">
              INSS s/ 13º Salário
            </td>
            <td>
              {{ resultado.descontos.insS13Salario }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              INSS s/ Salário Indenizado
            </td>
            <td>
              {{ resultado.descontos.insS13SalarioIndenizado }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              INSS s/ Salário
            </td>
            <td>
              {{ resultado.descontos.inssSalario }}
            </td>
          </tr>
        </table>
        <br>
        <table class="t01">
          <tr>
            <th colspan="2">
              IRRF
            </th>
          </tr>
          <tr>
            <td class="ladoEs">
              Aviso Prévio
            </td>
            <td>
              {{ resultado.irrf.valorSobreAvisoPrevio }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              Saldo Salário
            </td>
            <td>
              {{ resultado.irrf.valorSobreSalarios }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              13º Salário
            </td>
            <td>
              {{ resultado.irrf.valorSobre13Salario }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs" style="background:#E8E8E8;">
              Total
            </td>
            <td style="background:#E8E8E8;">
              {{ resultado.irrf.valorTotal }}
            </td>
          </tr>
        </table>
        <br>
        <table class="t01">
          <tr>
            <th colspan="2">
              Descontos
            </th>
          </tr>
          <tr>
            <td class="ladoEs">
              Aviso Prévio
            </td>
            <td>
              {{ resultado.descontos.avPrevio }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              Outros Descontos
            </td>
            <td>
              {{ resultado.descontos.outrosDescontos }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              IRRF
            </td>
            <td>
              {{ resultado.descontos.irrf }}
            </td>
          </tr>

          <tr>
            <td class="ladoEs" style="background:#E8E8E8;">
              Total Descontos
            </td>
            <td style="background:#E8E8E8;">
              {{ resultado.descontos.totalDescontos }}
            </td>
          </tr>
        </table>
        <br>
        <table class="t01">
          <tr>
            <th colspan="2">
              FGTS
            </th>
          </tr>
          <tr>
            <td class="ladoEs">
              13º Salário
            </td>
            <td>
              {{ resultado.fgts.valor13Salario }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              13º Salário/Férias
            </td>
            <td>
              {{ resultado.fgts.valor13SalarioFerias }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              Mês atual
            </td>
            <td>
              {{ resultado.fgts.mesAtual }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              Aviso Prévio
            </td>
            <td>
              {{ resultado.fgts.avPrevio }}
            </td>
          </tr>

          <tr>
            <td class="ladoEs">
              Total FGTS
            </td>
            <td>
              {{ resultado.fgts.totalFGTS }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs">
              Multa 40%
            </td>
            <td>
              {{ resultado.fgts.multa }}
            </td>
          </tr>
          <tr>
            <td class="ladoEs" style="background:#E8E8E8;">
              Total Geral FGTS - CAIXA
            </td>
            <td style="background:#E8E8E8;">
              {{ resultado.fgts.totalGeral }}
            </td>
          </tr>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import services from '../services/services.js'
import { Money } from 'v-money';
import topOp from '../shared/topOp.vue';
export default {
  components: {
    'topOp': topOp,
    Money
  },
  data() {
    return {
      dataAfastamento: '',
      dependeteSalario: 0,
      verCon: false,
      erro: false,
      verbas: null,
      dataInicio: '',
      dataFim: '',
      feriasVencidas: '',
      feriasGoazadas: '',
      disabled: false,
      spiner: false,
      exibirCheck: false,
      salario: 0,
      dependentesIR: 0,
      recisao: false,
      salario12: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      porcentagem: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      resuIs: false,
      resultado: ''
    }
  },
  methods: {
    recisaoF() {
      let motivoTermino = document.getElementById('motivoTermino').selectedOptions[0].value
      if (motivoTermino == '4' || motivoTermino == 5) {
        this.recisao = true
      } else {
        this.recisao = false
      }
    },
    async calcular() {
      this.resultado = ''
      this.spiner = true
      let motivoTermino = document.getElementById('motivoTermino').selectedOptions[0].value
      let possui = document.getElementById('possuiFe').selectedOptions[0].value;
      let avisoPrevio = document.getElementById('avisoPrevio').selectedOptions[0].value
      let verbas = document.getElementById('verdas').selectedOptions[0].value
      var montarObj = {}
      if (!this.recisao) {
        montarObj = {
          "dependentesSalarioFamilia": parseInt(this.dependeteSalario),
          "dataInicio": this.dataInicio,
          "dataTermino": this.dataFim,
          "motivoTermino": parseInt(motivoTermino),
          "salarioNormal": this.salario,
          //"mediaSalarialVariavel":this.salario12,
          // "gratificacao":0,
          "dependentesIR": parseInt(this.dependentesIR),
          "avisoPrevio": parseInt(avisoPrevio),
          "feriasVencidas": possui == "1" ? true : false,
          "feriasGozadas": parseInt(this.feriasGoazadas),
          "descontosVerbas": verbas == "true" ? true : false
        }

      } else {
        montarObj = {
          "dependentesSalarioFamilia": parseInt(this.dependeteSalario),
          "dataInicio": this.dataInicio,
          "dataTermino": this.dataFim,
          "motivoTermino": parseInt(motivoTermino),
          "salarioNormal": this.salario,
          "dataAfastamento": this.dataAfastamento,
          "dependentesIR": parseInt(this.dependentesIR),
          //"mediaSalarialVariavel":this.salario12,
          // "gratificacao":0,
          //"avisoPrevio":parseInt(avisoPrevio),
          //"feriasVencidas":possui == "1" ? true : false,
          //"feriasGozadas": parseInt(this.feriasGoazadas),
          "descontosVerbas": verbas == "true" ? true : false
        }
      }


      console.log(montarObj)
      this.resCalculo = await services.getCalcularContrato(montarObj)
      if (this.resCalculo == undefined) {
        this.spiner = false;
        this.erro = true
        return;
      } else {
        this.resuIs = true
        this.erro = false
        this.spiner = false;
        this.resultado = this.resCalculo
        console.log(this.resultado)
      }
    },
    limpar() {
      this.dataInicio = ''
    }
  },
  watch: {
    dataFim(novo) {
      if (novo.length == 3 && !(novo[(novo.length - 1)] == '/')) {
        this.dataFim = this.dataFim.replace(/(\d{2})/, "$1/")
      } else if (novo.length == 6 && !(novo[(novo.length - 1)] == '/')) {
        this.dataFim = this.dataFim.replace(/((\d{2}).(\d{2}))/, "$1/");
      }
      this.dataFim = this.dataFim.replace(/[A-Za-z]/, '')
      this.dataFim = this.dataFim.replace(/[!@#$%¨&*)(+´^>}{.,|"<;:]/, '')
    },
    dataAfastamento(novo) {
      if (novo.length == 3 && !(novo[(novo.length - 1)] == '/')) {
        this.dataAfastamento = this.dataAfastamento.replace(/(\d{2})/, "$1/")
      } else if (novo.length == 6 && !(novo[(novo.length - 1)] == '/')) {
        this.dataAfastamento = this.dataAfastamento.replace(/((\d{2}).(\d{2}))/, "$1/");
      }
      this.dataAfastamento = this.dataAfastamento.replace(/[A-Za-z]/, '')
      this.dataAfastamento = this.dataAfastamento.replace(/[!@#$%¨&*)(+´^>}{.,|"<;:]/, '')
    },
    dataInicio(novo) {
      if (novo.length == 3 && !(novo[(novo.length - 1)] == '/')) {
        this.dataInicio = this.dataInicio.replace(/(\d{2})/, "$1/")
      } else if (novo.length == 6 && !(novo[(novo.length - 1)] == '/')) {
        this.dataInicio = this.dataInicio.replace(/((\d{2}).(\d{2}))/, "$1/");
      }
      this.dataInicio = this.dataInicio.replace(/[A-Za-z]/, '')
      this.dataInicio = this.dataInicio.replace(/[!@#$%¨&*)(+´^>}{.,|"<;:]/, '')
    }
  },

}
</script>

<style>
.contrato {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 110px;
  padding-right: 110px;
  padding-bottom: 30px;
  padding-top: 30px;
}

.ladoEs {
  width: 400px;
  text-align: left;
  padding: 10px;
  font-weight: bold;
}

table,
th,
td {
  border: 1px solid #707070;
  border-collapse: collapse;
  color: black;
  background: #fff;
  min-width: 130px;

}

.t01 th {
  background-color: #F7B733;
  color: black;
  padding: 10px;

}

.lis div {
  display: flex;
  justify-content: center;
  align-items: center;
}

label {
  display: inline-block;
  /* margin-bottom: 0rem !important;
    margin-left:10px; */
}

#modal-1___BV_modal_footer_ {
  display: none;
}

.calcular:focus {
  outline: none;
}

div.input-group-text {
  border-left: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}

.resultHorasExtras {
  width: 370px;
  height: 45px;
  border-radius: 10px;
  padding-left: 10px;
}

.container-flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center
}

.box {
  width: 360px;
  height: 45px;
  background: #fff;
}

.resultado {
  width: 407px;
  height: 45px;
  background: #fff;
}

.pResult {
  text-align: left;
  margin-bottom: 5px;
  margin-top: 10px;
  margin-left: 2px;
}

.calcular {
  float: right;
  background: #FF7835 0% 0% no-repeat padding-box;
  border: 2px solid #FF7835;
  border-radius: 5px;
  width: 170px;
  font-size: 21px;
  height: 48px;
  color: #fff;
  margin-top: -10px;
  font-weight: 600;
  cursor: pointer;
  font-style: italic;
}

.calcular:hover {
  background: #e64d00;
  border: 1px solid #e64d00;
}

.limpar {
  float: left;
  border: 2px solid #FF7835;
  border-radius: 5px;
  background: #fff;
  padding: 5px;
  font-weight: 500;
  font-size: 15px;
  width: 105px;
  cursor: pointer;
  font-style: italic;
}

input.formatacaoInput {
  /* border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070; */
  border-radius: 10px;
  height: 43px;
}

.horasExtrasresultado {
  padding-left: 110px;
  padding-right: 110px;
  padding-bottom: 30px;
  padding-top: 30px;
}

.horasExtras {
  padding-left: 110px;
  padding-right: 110px;
}

h3 {
  border-bottom: 1px solid #707070;
  padding-bottom: 6px;
  text-align: left;
  font-weight: bold;
  font-size: 26px;
}

.formAjuste {
  width: 370px;
  margin: 0px auto;
  position: relative;
  top: -40px;
}

#formAjuste2 {
  width: 370px;
  margin: 20px auto;
}

input {
  border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
}

@media only screen and (max-width: 767px) {
  .horasExtras {
    margin-top: 445px;
  }

  #formAjuste2 {
    width: 320px;
  }
}

@media only screen and (max-width: 767px) {
  #formAjuste2 {
    width: 300px;
    margin: 20px auto;
  }

  .horasExtras {
    padding-left: 80px;
  }
}

@media only screen and (max-width: 400px) {
  #formAjuste2 {
    width: 230px;
    margin: 20px auto;
  }

  .limpar {
    width: 88px;
  }

  .calcular {
    width: 126px;
    height: 37px;
    margin-top: 0px;
  }
}

@media only screen and (max-width: 490px) {
  .horasExtrasresultado {
    margin-top: 30px;
    padding-left: 40px;
    padding-right: 110px;
    padding-bottom: 30px;
    padding-top: 30px;
  }

  .resultHorasExtras {
    width: 300px;
    height: 45px;
    border-radius: 10px;
    padding-left: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/screens/ContratoTrabalho.vue